export const CATEGORY_DETAILS_LOADED = "CATEGORY_DETAILS_LOADED";
export const SET_CATEGORY_BREADCRUMBS = "SET_CATEGORY_BREADCRUMBS";
export const SET_CATEGORY_GENDER = "SET_CATEGORY_GENDER";
export const SET_CATEGORY_SERVER_ERROR = "SET_CATEGORY_SERVER_ERROR";
export const SET_CATEGORY_CHILD_LINKS = "SET_CATEGORY_CHILD_LINKS";
export const SET_CATEGORY_IS_BRAND = "SET_CATEGORY_IS_BRAND";
